import { Alert } from "@material-ui/lab"
import { MyDialog } from "../../../components/Dialog"
import { ReservationForm } from "../../public/component/ReservationForm"
import { getTranslation } from "../../../heplers/translationHelper";

export const AddReservationModal=({open,onClose,refreshReservations})=>{
    return <MyDialog open={open} onClose={onClose} title={getTranslation("Add Reservation")} fullScreen>
        <Alert severity="warning" >{getTranslation("By adding reservation from staff screen, you can override max capacity.")}</Alert>
     <ReservationForm
     onCloseDialog={onClose}
     refreshReservations={refreshReservations}
     
    />
    </MyDialog>
}